module.exports = __webpack_public_path__ + "fonts/MullerThin.8c092ff8.ttf";